var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.024,
    height: 31.933,
    viewBox: "0 0 20.024 31.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1066",
    "data-name": "Groupe 1066",
    transform: "translate(2903.815 -612.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10417",
    "data-name": "Trac\\xE9 10417",
    d: "M-2886.129,642.457h-.082a.293.293,0,0,1-.229-.11l-2.32-2.881a.29.29,0,0,1,.08-.431,8.286,8.286,0,0,0,4.047-7.077,8.252,8.252,0,0,0-2.867-6.209.285.285,0,0,1-.019-.421,1.339,1.339,0,0,0,.4-.954,1.345,1.345,0,0,0-.662-1.158.285.285,0,0,1-.094-.38l.955-1.78-.547-.293,1.693-3.156a.294.294,0,0,0-.12-.4l-2.143-1.149a.294.294,0,0,0-.4.121l-1.693,3.156-.547-.293-4.493,8.374.26.139-.263.491.292.157-.622,1.158a.3.3,0,0,0-.007.266l.387.81h0l-1.013,1.888a.294.294,0,0,0,.121.4l.652.349a.293.293,0,0,0,.4-.12l1.013-1.888,0,0,.889-.126a.3.3,0,0,0,.218-.152l.622-1.158.292.157.263-.491.25.134,1.163-2.168a.3.3,0,0,1,.42-.113,5.758,5.758,0,0,1,2.668,4.808,5.909,5.909,0,0,1-6,5.8,6.232,6.232,0,0,1-1.635-.224.865.865,0,0,0,.073-.347.863.863,0,0,0-.415-.726v-.3h.653v-.8h-9v.8h.652v.668h6.441a.869.869,0,0,0-.079.356.841.841,0,0,0,.052.26l-.826,1.474a.3.3,0,0,0,.12.411,8.7,8.7,0,0,0,3.969.955,8.692,8.692,0,0,0,1.22-.1l-.664,2.06a.293.293,0,0,1-.279.2h-8.948a1.981,1.981,0,0,0-1.981,1.98v.069a.294.294,0,0,0,.294.294h19.078a.294.294,0,0,0,.293-.294v-.069A1.98,1.98,0,0,0-2886.129,642.457Z",
    transform: "translate(0 -0.587)",
    fill: "#FFC43E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698",
    "data-name": "Rectangle 1698",
    width: 3.288,
    height: 3.682,
    transform: "matrix(0.473, -0.881, 0.881, 0.473, -2888.59, 615.178)",
    fill: "#FFC43E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.79143141774acf861bb11fe11b0ee303.svg";
export { ForwardRef as ReactComponent };